<template>
  <div class="disclaimer">
    <info-icon class="info-icon" />
    <p> {{ message }}</p>
  </div>
</template>

<script setup lang="ts">
import InfoIcon from '@/assets/InfoIcon.svg'

const props = defineProps<{
  message: string;
}>()
</script>

<style lang="scss">
.disclaimer {
  display: flex;
  align-items: center;
  font-size: 10px;
  color: $grey-55;
  gap: 3px;

  .info-icon path {
    fill: currentColor;
  }
}
</style>
